var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              [
                _vm.activateSpinner
                  ? _c("spinner")
                  : _vm.listItems.length > 0
                  ? _c("b-table", {
                      staticClass: "table-striped",
                      attrs: {
                        items: _vm.listItems,
                        fields: _vm.fields,
                        "sort-by": _vm.sortBy,
                        fixed: "",
                        hover: "",
                        selectable: _vm.listItems.length > 0,
                        "empty-text": "Pas de résultat",
                      },
                      on: {
                        "update:sortBy": function ($event) {
                          _vm.sortBy = $event
                        },
                        "update:sort-by": function ($event) {
                          _vm.sortBy = $event
                        },
                        "row-selected": _vm.onRowSelected,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "cell(name)",
                          fn: function (data) {
                            return [_c("span", [_vm._v(_vm._s(data.value))])]
                          },
                        },
                        {
                          key: "cell(type)",
                          fn: function (data) {
                            return [_c("span", [_vm._v(_vm._s(data.value))])]
                          },
                        },
                        {
                          key: "cell(edit)",
                          fn: function (data) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-center d-inline-block py-3 w-100",
                                  on: {
                                    click: function ($event) {
                                      return _vm.actionEdit($event, data.value)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-pencil",
                                  }),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(delete)",
                          fn: function (data) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-center d-inline-block py-3 w-100",
                                  on: {
                                    click: function ($event) {
                                      return _vm.actionDelete(
                                        $event,
                                        data.value
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-trash",
                                  }),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    })
                  : _c(
                      "label",
                      {
                        staticClass:
                          "font-bold w-100 d-flex justify-content-center mt-3",
                      },
                      [_vm._v(_vm._s(_vm.$t("common.no_result")))]
                    ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }